module.exports = __webpack_public_path__ + "static/media/CNYCN-logo.64beb869.svg";